// extracted by mini-css-extract-plugin
module.exports = {"root":"cmp-Icon__icon__root"};